import axios from 'axios';

export function authHeader() {
  const token = localStorage.getItem('access_token')

  return token ? { 'Authorization' : 'Bearer ' + token, 'Content-Type' : 'application/json,multipart/form-data', 'Accept': 'application/json'} : {'Content-Type' : 'application/json', 'Accept': 'application/json'}
};

export function pdfHeader() {
  const token = localStorage.getItem('access_token')

  return token ? { 'Authorization' : 'Bearer ' + token} : {}
}

export default axios.create({
  baseURL: process.env.REACT_APP_API
});
